<template>
  <v-layout column class="droppable-file-container w-100 pb-0" :class="{ active: isDragging }">
    <v-flex shrink>
      <v-layout row wrap>
        <v-flex xs12>
          <v-toolbar flat color="k-orange-linear">
            <v-toolbar-title>Vista previa</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="closePreview">
              <v-icon color="white">fa-times</v-icon>
            </v-btn>
          </v-toolbar>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex h-100>
      <v-container grid-list-lg fluid fill-height id="droppable-file">
        <v-layout row wrap :class="{ bordered: previewFile == '' }" justify-center align-center fill-height ma-0>
          <v-flex xs12>
            <div class="d-flex align-center" v-if="previewFile == ''">
              <h2 class="text-xs-center blue-grey--text darken-1">
                Arrastre y suelte su archivo aquí o haga click para buscar...
              </h2>
            </div>
            <div v-else>
              <div v-if="!isFileImage" class="text-xs-center">
                <span class="fa-stack fa-2x">
                  <i class="far fa-file fa-stack-2x"></i>
                  <span class="fas fa-stack-1x" style="font-size: .5em !important">{{ extention }}</span>
                </span>
                {{ fileName }}
              </div>
              <img :src="previewFile" class="img-responsive d-block mx-auto preview-image" v-else>
            </div>
          </v-flex>
        </v-layout>
        <input type="file" class="droppable-input" :name="uploadFieldName" @change="filesChange">
      </v-container>
    </v-flex>
    <v-flex shrink>
      <v-container grid-list-lg fluid py-0>
        <v-layout row wrap>
          <v-flex >
            <v-text-field
              name="input-3"
              placeholder="Escribe un mensaje..."
              color="black"
              class="mt-0"
              v-model="fileText">
              </v-text-field>
          </v-flex>
          <v-flex shrink>
            <v-btn icon large :class="{ 'k-orange-linear': file, 'default': !file }" :disabled="!file" @click="sendAttachment">
              <v-icon>send</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

const uuidv1 = require('uuid/v1');

export default {
  // mounted() {
  //   const element = document.getElementById('droppable-file');
  //   element.addEventListener("drop", (e) => {
  //     e.preventDefault();
  //     const files = e.dataTransfer.files;
  //     console.log('Drop files:', files);
  //     this.file = files[0];
  //     const fileReader = new FileReader();
  //     fileReader.onload = (fileLoadedEvent) => {
  //       this.fileUrl = fileLoadedEvent.target.result;
  //     }
  //     fileReader.readAsDataURL(this.file);
  //     // this.uploadFile(files);
  //   });
  // },
  mounted() {
    this.reset();
  },
  props: {
    chat: {
      type: Object,
      default: () => {},
    },
    text: {
      type: String,
      default: '',
    },
    creating: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      file: null,
      fileText: '',
      previewFile: '',
      uploadError: null,
      ajaxOn: false,
      uploadFieldName: 'Archivo',
    };
  },
  computed: {
    ...mapGetters([
      'isDragging',
    ]),
    fileName() {
      if (this.file) {
        return this.file.name;
      }
      return null;
    },
    extention() {
      if (this.fileName) {
        // eslint-disable-next-line
        return this.fileName.slice((this.fileName.lastIndexOf('.') - 1 >>> 0) + 2);
      }
      return null;
    },
    isFileImage() {
      const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
      return this.file && acceptedImageTypes.includes(this.file.type);
    },
    routeMessage() {
      let route = `chats_center/${this.chat.id}/messages`;
      if (this.creating) {
        route = `chats_center/initiate`;
      }
      return route;
    },
  },
  methods: {
    reset() {
      // reset form to initial state
      this.ajaxOn = false;
      this.previewFile = '';
      this.uploadError = null;
    },
    filesChange(event) {
      const file = event.target.files[0];
      if (!file) {
        return false;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        this.previewFile = e.target.result;
      };
      reader.readAsDataURL(file);
      this.file = file;
      return false;
    },
    sendAttachment() {
      if (this.creating && this.chat.channel_id === 1 && (!this.form.subject || !this.form.email)) {
        this.$store.commit('SET_DRAG', false);
        this.$emit('show-set-email');
      } else if (this.file) {
        this.ajaxOn = true;
        const message = {
          identifier: uuidv1(),
          chat_center_id: this.chat.id,
          origin: 1,
          type: 'media',
          text: {
            caption: this.fileText ? this.fileText : '',
            files: [
              {
                extension: this.extention,
                url: this.previewFile,
                filename: this.fileName,
                type: this.isFileImage ? 'image' : 'media',
              },
            ],
          },
          status: 'Enviado',
          created_at: moment().utc().format('YYYY-MM-DD HH:mm:ss'),
          user: {
            first_name: this.$auth.user().first_name,
            last_name: this.$auth.user().last_name,
          },
        };
        this.$emit('appendMessagesToChat', message);

        const payload = new FormData();
        payload.append('file', this.file);
        payload.append('text', this.fileText);
        payload.append('identifier', message.identifier);
        if (this.creating) {
          const chat = _.pick(this.chat, ['customer', 'internal_id', 'channel_id']);
          chat.customer = _.pick(chat.customer, ['id']);
          payload.append('chatCenter', JSON.stringify(chat));
          payload.append('email', this.form.email);
          payload.append('subject', this.form.subject);
        }
        this.axios.post(this.routeMessage, payload, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Socket-ID': window.Echo.socketId(),
          },
        }).then(({ data }) => {
          this.ajaxOn = false;
          this.$emit('updateSendedMessage', {
            id: data.chat_center_message.chat_center_id,
            identifier: data.identifier,
            chatCenterMessage: data.chat_center_message,
          });
          this.$emit('updateActiveChat', {
            id: data.chat_center_message.chat_center_id,
            status: 'Por resolver',
            unread_messages: 0,
          });
          this.closePreview();
        }).catch((error) => {
          this.ajaxOn = false;
          const chatCenterMessages = this.chat.chat_center_messages;
          const identifier = error.response.data.data.identifier;
          const index = chatCenterMessages.findIndex(item => item.identifier === identifier);
          chatCenterMessages[index].status = 'Error';
          this.$emit('updateSendedMessage', {
            id: error.response.data.data.chat_center_message.chat_center_id,
            identifier: error.response.data.data.identifier,
            chatCenterMessages,
          });
        });
        this.fileText = '';
      }
    },
    closePreview() {
      this.reset();
      this.$store.commit('SET_DRAG', false);
    },
  },
  watch: {
    text: {
      immediate: true,
      handler(value) {
        this.fileText = value;
      },
    },
  },
};
</script>

<style scoped>
  .droppable-file-container {
    top: 100%;
    height: 100%;
    z-index: 100;
    position: absolute;
    transition: top .25s ease-out;
    background-color: #e5e5e5;
  }
  .droppable-file-container.active {
    top: 0;
  }
  #droppable-file {
    position: relative;
  }
  .droppable-input {
    top: 16px;
    left: 16px;
    width: calc(100% - 32px);
    height: calc(100% - 32px);
    cursor: pointer;
    z-index: 1;
    opacity: 0;
    position: absolute;
  }
  .bordered {
    border: 5px dashed #7f7f7f;
  }
  .img-responsive {
    height: 125px;
  }
</style>



// WEBPACK FOOTER //
// src/components/global/DroppableFile.vue